"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendStartEvent = sendStartEvent;
exports.sendSuccessEvent = sendSuccessEvent;
exports.sendErrorEvent = sendErrorEvent;
const globalVars_1 = require("../common/globalVars");
const telemetry_1 = require("../common/telemetry");
function getCommonProperties() {
    const props = {
        [telemetry_1.TelemetryProperty.AppId]: globalVars_1.globalVars.teamsAppId,
        [telemetry_1.TelemetryProperty.TenantId]: globalVars_1.globalVars.m365TenantId,
    };
    return props;
}
function sendStartEvent(eventName, properties, measurements) {
    const props = {
        ...getCommonProperties(),
        ...properties,
    };
    globalVars_1.TOOLS.telemetryReporter?.sendTelemetryEvent(eventName + "-start", props, measurements ?? {});
}
function sendSuccessEvent(eventName, properties, measurements) {
    const props = {
        ...getCommonProperties(),
        ...properties,
        [telemetry_1.TelemetryProperty.Success]: telemetry_1.TelemetrySuccess.Yes,
    };
    globalVars_1.TOOLS.telemetryReporter?.sendTelemetryEvent(eventName, props, measurements ?? {});
}
function sendErrorEvent(eventName, error, properties, measurements) {
    const props = {
        ...getCommonProperties(),
        ...properties,
    };
    telemetry_1.telemetryUtils.fillInErrorProperties(props, error);
    globalVars_1.TOOLS.telemetryReporter?.sendTelemetryErrorEvent(eventName, props, measurements ?? {}, [
        telemetry_1.TelemetryProperty.ErrorMessage,
    ]);
}
//# sourceMappingURL=telemetry.js.map